/**
 * Default Vector Dashboard layout — stacked full-width Vector Capital sections.
 * Matches the production Vector Capital page order (top → bottom).
 */

export const OVERVIEW_TEST_WIDGETS = [
  { id: 'vc-topbar', type: 'vcTopbar', config: {} },
  { id: 'vc-controls', type: 'vcControls', config: {} },
  { id: 'vc-chart', type: 'vcGrowthChart', config: {} },
  { id: 'vc-comparison', type: 'vcComparison', config: {} },
  { id: 'vc-calendar', type: 'vcCalendar', config: {} },
  { id: 'vc-monthly', type: 'vcMonthlyReturns', config: {} },
  { id: 'vc-trades', type: 'vcTradesList', config: {} },
  { id: 'vc-insights', type: 'vcKeyInsights', config: {} },
  { id: 'vc-calculator', type: 'vcGrowthCalculator', config: {} },
  { id: 'vc-disclosures', type: 'vcDisclosures', config: {} },
];

export const OVERVIEW_TEST_LAYOUT = {
  order: OVERVIEW_TEST_WIDGETS.map((w) => w.id),
  hidden: [],
  sizes: {
    'vc-topbar': { col: 1, row: 1, w: 12, h: 2 },
    'vc-controls': { col: 1, row: 3, w: 12, h: 5 },
    'vc-chart': { col: 1, row: 8, w: 12, h: 9 },
    'vc-comparison': { col: 1, row: 17, w: 12, h: 10 },
    'vc-calendar': { col: 1, row: 27, w: 12, h: 8 },
    'vc-monthly': { col: 1, row: 35, w: 12, h: 6 },
    'vc-trades': { col: 1, row: 41, w: 12, h: 8 },
    'vc-insights': { col: 1, row: 49, w: 12, h: 6 },
    'vc-calculator': { col: 1, row: 55, w: 12, h: 6 },
    'vc-disclosures': { col: 1, row: 61, w: 12, h: 4 },
  },
};
